import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { HomeFilled, PlusCircleFilled, MinusCircleFilled, InfoCircleFilled, CloseCircleFilled, CloseOutlined, DeleteFilled, CloudUploadOutlined, DeleteOutlined } from '@ant-design/icons';
import { Modal, Spin, Button, Carousel, Tooltip } from 'antd';
// import Uploadlayer from '../../../../components/FormComponent/Input/upload';
import networkList from '../../../constants/networkList';
import postService from '../../../services/httpService';
import Storage from './../../../services/local-store';

const $ = require('jquery');
const {homepage} = networkList;
class View_document extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        this.checkAuthToken()
        var h = window.innerHeight;
        var x = document.getElementById("view-document");
        x.style.height = `${h}px`;
    }
    checkAuthToken() {
        const setHref = str => (window.location.href = str);
        const currenthref = window.location.pathname;
        console.log("test the refresh..." + currenthref);
        if (currenthref !== `${homepage}/tv-display` && currenthref !== `${homepage}/nurse-display` && currenthref !== `${homepage}/nurse-stations` && currenthref !== `${homepage}/digital-signature`) {
            postService('checkAuthToken', 'GET', "").then(res => {
                if (!(res.success) && !(res.status)) {
                    // console.log("token service checking in....");
                    // console.log(res)
                    if (currenthref !== `${homepage}/tv-settings/start-counter` && currenthref !== '/' && currenthref !== `${homepage}/tv-screen/tv1` && currenthref !== `${homepage}/tv-screen/tv2` && currenthref !== `${homepage}/tv-screen/tv3` && currenthref !== `${homepage}/tv-screen/tv4` && currenthref !== `${homepage}/tv-screen/tv5` && currenthref !== `${homepage}/tv-screen/ramesh_tv`) {
                        Storage.clearAll();
                        setHref('/');
                    }
                }
            });
        }
    }
   
    downloadEmployeeData = () => {        
        const params = new URLSearchParams(this.props.location.search);
        const umr_no = params.get('uid');
        const ip_no = params.get('ip');
        const patient_name = params.get('name');
        const file = params.get('file');
        let { base_url } = networkList
		fetch(`${base_url}uploads/${umr_no}/${file.replaceAll("_ampersand_", "&")}`)
			.then(response => {
				response.blob().then(blob => {
					let url = window.URL.createObjectURL(blob);
					let a = document.createElement('a');
					a.href = url;
					a.download = file;
					a.click();
				});
				//window.location.href = response.url;
		});
	}
    render() {
        const params = new URLSearchParams(this.props.location.search);
        const umr_no = params.get('uid');
        const ip_no = params.get('ip');
        const patient_name = params.get('name');
        const file = params.get('file');
        let { base_url } = networkList
        return (
            <div className='p-5' style={{marginTop:'-115px'}}>
                <div className="row pb-3">
                    <div className="col-6">
                   <h6><Tooltip title="Patient Name">{patient_name}</Tooltip></h6>
                    </div>
                    <div className="col-2">
                        <h6><Tooltip title="UMR Number">{umr_no ? umr_no : '--'}</Tooltip></h6>
                    </div>
                    <div className="col-2">
                        <h6><Tooltip title="IP Number">{ip_no && ip_no  !=='null' ? ip_no : '--'}</Tooltip></h6>
                    </div>
                    <div className="col-2 my-auto">
                            <button className="btn btn-success text-capitalize float-right" onClick={()=>{this.downloadEmployeeData() }}>
                                <img src={homepage+"/assets/images/icons/download1.png"} alt="" className="pr-2" /> <span> Download</span>
                            </button>
                    </div>
                    <div className="col-12">
                    <iframe src={`${base_url}uploads/${umr_no}/${file.replaceAll("_ampersand_", "&")}`} width="100%" id="view-document"></iframe>
                    </div>
                </div>
            </div>
        )
    }
}
export default View_document;